import React from "react";
import ReactSelect from "react-select";

const SelectInput = ({
  value,
  onChange,
  options,
  isSearchable = false,
  placeholder = "Select option",
  className = "",
  ...props
}) => {
  const classNameStr = `c-select ${className}`;

  return (
    <ReactSelect
      value={value}
      onChange={onChange}
      options={options}
      isSearchable={isSearchable}
      placeholder={placeholder}
      className={classNameStr}
      classNamePrefix="c-select"
      {...props}
    />
  );
};

export default SelectInput;
